import { Application } from "pixi.js";
import { Obstacle } from "./Obstacle";
import {
  backgroundColor,
  baseObstacleSpeed,
  randomYPos,
  randomXPos,
  randomCircleColor,
  circleColors,
  circleRadius,
  randomFullYPos,
} from "../config";
import TrailParticle from "./TrailParticle";
import Circle from "./Circle";

export class MenuBackground {
  app: Application;

  constructor() {
    this.app = new Application();
  }

  async init(
    parent: HTMLElement,
    width: number,
    height: number,
  ): Promise<void> {
    await this.app.init({
      width,
      height,
      backgroundColor: backgroundColor(),
      antialias: true,
    });
    parent.append(this.app.canvas);

    circleColors().map(this.addObstacle);
    circleColors().map(this.addObstacle);
    circleColors().map(this.addObstacle);
    circleColors().map(this.addObstacle);
  }

  private addObstacle = (color: number) => {
    const newCircle = new Obstacle({
      speed: baseObstacleSpeed,
      y: randomFullYPos(),
      x: randomXPos(),
      color,
    });

    this.app.stage.addChild(newCircle);
    this.app.ticker.add((ticker) => {
      newCircle.update(ticker.deltaTime);
      this.addTrailParticle(newCircle, 0.85);
    });
  };

  private addTrailParticle = (circle: Circle, duration?: number) => {
    const particle = new TrailParticle({
      x: circle.x,
      y: circle.y,
      color: circle.color,
      radius: circleRadius * 0.3,
      duration,
    });
    this.app.stage.addChildAt(particle, 0); // Add behind other objects
  };

  destroy = () => {
    if (this.app) {
      this.app.destroy(true);
      delete this.app;
    }
  };
}
